import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, setToken, getRefreshToken, removeToken, removeRefreshToken } from './auth'
import { refreshToken } from '@/api/auth'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 10000
})

// 是否正在刷新token
let isRefreshing = false
// 等待刷新token的队列
let refreshSubscribers = []

function onTokenRefreshed(newToken) {
  refreshSubscribers.forEach(cb => cb(newToken))
  refreshSubscribers = []
}

function addRefreshSubscriber(cb) {
  refreshSubscribers.push(cb)
}

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // 如果是 FormData，让浏览器自动设置 Content-Type（包含 boundary）
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = undefined
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    // 如果是文件下载，直接返回原始响应
    if (response.config.responseType === 'blob') {
      return response.data
    }
    
    const res = response.data
    
    // 如果后端直接返回 Boolean 或其他非标准格式，直接返回
    if (typeof res === 'boolean' || typeof res === 'string' || typeof res === 'number') {
      return res
    }
    
    if (res.code !== 200) {
      // 423: 账号被锁定
      if (res.code === 423) {
        Message.error(res.message || '账号被锁定')
        return Promise.reject(new Error(res.message || '账号已被锁定'))
      }
      Message.error(res.message || '请求失败')
      if (res.code === 401) {
        removeToken()
        removeRefreshToken()
        router.push('/login')
      }
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  error => {
    const { config, response } = error

    // 处理401 token过期，尝试刷新
    if (response && response.status === 401) {
      const refreshTokenValue = getRefreshToken()
      if (!refreshTokenValue) {
        Message.error('登录已过期，请重新登录')
        removeToken()
        removeRefreshToken()
        router.push('/login')
        return Promise.reject(error)
      }

      if (!isRefreshing) {
        isRefreshing = true
        refreshToken({ refreshToken: refreshTokenValue }).then(res => {
          const { accessToken, refreshToken: newRefreshToken } = res.data
          setToken(accessToken)
          if (newRefreshToken) {
            // 如果后端返回了新的refreshToken，也更新
            // setRefreshToken(newRefreshToken)
          }
          isRefreshing = false
          onTokenRefreshed(accessToken)
        }).catch(() => {
          isRefreshing = false
          Message.error('登录已过期，请重新登录')
          removeToken()
          removeRefreshToken()
          router.push('/login')
        })
      }

      // 将当前请求加入队列，等待token刷新后重试
      return new Promise(resolve => {
        addRefreshSubscriber(newToken => {
          config.headers['Authorization'] = 'Bearer ' + newToken
          resolve(service(config))
        })
      })
    }

    Message.error((response && response.data && response.data.message) || '网络错误')
    return Promise.reject(error)
  }
)

export default service
